import {
  IconPhone,
  IconBrandWhatsapp,
  IconMailOpened,
  IconMail,
  IconMailForward,
  IconMailCheck,
  IconBrandInstagram,
  IconBrandYoutube,
  IconBrandLinkedin,
  IconBrandFacebook,
  IconBrandX,
  IconUserFilled,
  IconSearch,
  IconTicket,
  IconShieldCheck,
  IconWorld,
  IconCalendarEvent,
  IconClipboardText,
  IconListCheck,
  IconCash,
  IconChartBar,
  IconFileSpreadsheet,
  IconUsers,
  IconDownload,
} from "@/lib/icons";

const ICON_MAP = {
  "phone-line": IconPhone,
  "phone-fill": IconPhone,
  "whatsapp-line": IconBrandWhatsapp,
  "mail-open-line": IconMailOpened,
  "mail-line": IconMail,
  "mail-add-fill": IconMailForward,
  "mail-fill": IconMail,
  "mail-check-line": IconMailCheck,
  "mail-check-fill": IconMailCheck,
  "instagram-fill": IconBrandInstagram,
  "instagram-line": IconBrandInstagram,
  "youtube-fill": IconBrandYoutube,
  "youtube-line": IconBrandYoutube,
  "linkedin-fill": IconBrandLinkedin,
  "linkedin-line": IconBrandLinkedin,
  "facebook-fill": IconBrandFacebook,
  "facebook-circle-fill": IconBrandFacebook,
  "facebook-line": IconBrandFacebook,
  "twitter-fill": IconBrandX,
  "twitter-line": IconBrandX,
  "twitter-x-line": IconBrandX,
  "twitter-x-fill": IconBrandX,
  "user-3-fill": IconUserFilled,
  "search-line": IconSearch,
  "coupon-3-line": IconTicket,
  "shield-check-line": IconShieldCheck,
  "earth-line": IconWorld,
  // For Organizers page (steps + analytics card icons)
  "calendar-event-line": IconCalendarEvent,
  "calendar-event-fill": IconCalendarEvent,
  "calendar-line": IconCalendarEvent,
  "calendar-2-line": IconCalendarEvent,
  "coupon-line": IconTicket,
  "coupon-fill": IconTicket,
  "coupon-2-line": IconTicket,
  "coupon-3-fill": IconTicket,
  "ticket-line": IconTicket,
  "ticket-2-line": IconTicket,
  "clipboard-line": IconClipboardText,
  "clipboard-fill": IconClipboardText,
  "file-list-3-line": IconClipboardText,
  "list-check": IconListCheck,
  "list-check-2": IconListCheck,
  "list-check-3": IconListCheck,
  "money-rupee-circle-line": IconCash,
  "wallet-3-line": IconCash,
  "cash-line": IconCash,
  "bar-chart-2-line": IconChartBar,
  "bar-chart-box-line": IconChartBar,
  "file-chart-line": IconChartBar,
  "file-excel-2-line": IconFileSpreadsheet,
  "file-excel-line": IconFileSpreadsheet,
  "group-line": IconUsers,
  "team-line": IconUsers,
  "user-follow-line": IconUsers,
  "download-2-line": IconDownload,
  "download-line": IconDownload,
  "file-download-line": IconDownload,
};

export function getRemixIcon(name) {
  if (!name) return null;
  return ICON_MAP[name] ?? null;
}
